import type { ReactNode } from "react";

import { css } from "@compiled/react";
import { FormattedMessage, type MessageDescriptor } from "react-intl";

const B300 = "#0065ff";

export const Message = ({ message }: { message: MessageDescriptor }) => {
    const progressLabelCss = css({
        "fontFamily": "var(--atlassian-recommended-system-fonts)",
        "marginTop": "0.5rem",
        "textAlign": "center",

        "h1, h2, h3, h4, h5": {
            fontSize: "inherit",
            fontWeight: 600,
            fontFamily: "inherit",
            lineHeight: "1.3rem",
            margin: "1rem 0"
        },
        "p": {
            lineHeight: "1.3rem",
            margin: "1rem 0"
        },
        "a": {
            "color": B300,
            "textDecoration": "none",

            "&:hover, &:focus": {
                textDecoration: "underline"
            }
        }
    });

    return (
        <div css={progressLabelCss}>
            <FormattedMessage
                {...message}
                values={{
                    "href-support": (node: ReactNode) => (
                        <a href="https://support.atlassian.com/contact/">
                            {node}
                        </a>
                    ),
                    "href-start": (node: ReactNode) => (
                        <a href="https://start.atlassian.com">{node}</a>
                    ),
                    "href-reload": (node: ReactNode) => (
                        // eslint-disable-next-line jsx-a11y/anchor-is-valid
                        <a href="javascript:window.location.reload(true)">
                            {node}
                        </a>
                    ),
                    "p": (node: ReactNode) => <p>{node}</p>,
                    "h1": (node: ReactNode) => <h1>{node}</h1>,
                    "h2": (node: ReactNode) => <h2>{node}</h2>,
                    "h3": (node: ReactNode) => <h3>{node}</h3>
                }}
            />
        </div>
    );
};
